var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_2749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 0C5.71629 0 0.333496 5.3828 0.333496 12C0.333496 18.6172 5.71629 24 12.3335 24C18.9507 24 24.3335 18.6163 24.3335 12C24.3335 5.38373 18.9507 0 12.3335 0ZM12.3335 22.141C6.74248 22.141 2.19251 17.592 2.19251 12C2.19251 6.40805 6.74248 1.85902 12.3335 1.85902C17.9254 1.85902 22.4745 6.40805 22.4745 12C22.4745 17.592 17.9245 22.141 12.3335 22.141Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8392 7.82644C17.4609 7.48251 16.8725 7.50947 16.5268 7.88962L10.8567 14.1332L8.11743 11.3484C7.75583 10.9822 7.1684 10.9766 6.8031 11.3372C6.43687 11.697 6.43129 12.2853 6.79194 12.6516L10.2209 16.1372C10.3966 16.3157 10.6345 16.4152 10.8836 16.4152C10.8892 16.4152 10.8957 16.4152 10.9013 16.4161C11.1578 16.4105 11.3995 16.3008 11.5715 16.1112L17.9024 9.13987C18.2473 8.75873 18.2194 8.1713 17.8392 7.82644Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_2749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRate);
export default __webpack_public_path__ + "static/media/successRate.1cf821a2a806bf87695e5001800e85ea.svg";
export { ForwardRef as ReactComponent };